<template>
  <div>
    <a-card style="margin:10px 0;">
      <SearchView
        :renderItem="searchSchema"
        :initialValues="searchData"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card style="margin:10px 0;">
      <TableView
        :data="tableData"
        :loading="tableLoading"
        :pagination="pageData"
        @handlePagination="handleClickPage"
        :columns="columns"
        :scroll="{ x: 2600 }"
      >
        <!--书面担保金额 writtenAmount -->
        <template v-slot:writtenAmount="{ tableRow }">
          <span>{{ tableRow.writtenAmount | formatAmount }}</span>
        </template>
        <!--担保金额(元) slot-->
        <template v-slot:validAmount="{ tableRow }">
          <span>{{ tableRow.validAmount | formatAmount }}</span>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { getTableData } from './api'
import { TableView, SearchView } from 'lxfintech-fe'
import { searchSchema, searchData, pageData, columns } from './approvejs'
import moment from 'moment'
// import { formatParamDate } from 'utils/util'
export default {
  data() {
    //这里存放数据
    return {
      searchSchema,
      searchData,
      pageData,
      tableLoading: false,
      columns,
      tableData: [],
    }
  },
  components: { TableView, SearchView },

  //方法集合
  methods: {
    // 获取表格数据
    async _getTableData() {
      this.tableLoading = true
      try {
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        if (query.date.length) {
          query.startTime = moment(query.date[0]).format('YYYY-MM-DD')
          query.endTime = moment(query.date[1]).format('YYYY-MM-DD')
        }
        delete query.date
        const {
          data: { total, records },
        } = await getTableData(query)
        this.pageData.total = total
        this.tableData = records
        this.tableData.map(item => {
          item.efficientDate = moment(item.efficientDate).format('YYYY-MM-DD')
          item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
        })
        this.tableLoading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 查询
    handleSearch(query) {
      this.searchData = { ...this.searchData, ...query }
      this.pageData.current = 1
      this._getTableData()
    },
    // 分页
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
    handleView(data) {
      this.$router.push({
        path: `/Item/guarantee-detail/guarantee-approval/${data.bpmId}`,
        query: {
          companyCode: data.companyCode,
        },
      })
    },
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getTableData()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
